<template>
  <div class="dataScreen">
    <div class="tabs">
      <div class="tabChange" @click="changeMap">切换地图</div>
    </div>
    <DataScreenMap v-if="mapIndex === 0"/>
    <TXMap v-else/>
    <div class="left">
      <AssessRank/>
      <TimeAssess/>
    </div>
    <div class="right">
      <AirQuality/>
      <AirRank/>
      <AlarmRecord/>
    </div>
  </div>
</template>

<script>
import AssessRank from "./components/AssessRank/index.vue";
import TimeAssess from "./components/TimeAssess/index.vue";
import AirQuality from "./components/AirQuality/index.vue";
import AirRank from "./components/AirRank/index.vue";
import AlarmRecord from "./components/AlarmRecord/index.vue";
import DataScreenMap from "./components/DataScreenMap";
import TXMap from "./components/TXMap";
export default {
  name: "index",
  components: {
    AssessRank,
    TimeAssess,
    AirQuality,
    AirRank,
    AlarmRecord,
    DataScreenMap,
    TXMap
  },
  data () {
    return {
      mapIndex: 0 // 0echart地图  1腾讯地图
    }
  },
  methods: {
    changeMap () {
      this.mapIndex = this.mapIndex === 0 ? 1 : 0
    }
  }
}
</script>

<style scoped lang="less">
.dataScreen{
  position: relative;
  width: 100vw;
  height: calc(100vh - 95px);
  .tabs{
    .tabChange{
      position: absolute;
      top: 10px;
      right: 700px;
      width: 140px;
      height: 43px;
      background-image: url("./assets/back-box.png");
      background-size: 100% 100%;
      font-size: 18px;
      font-weight: bold;
      color: #FFFFFF;
      text-align: center;
      line-height: 43px;
      cursor: pointer;
      z-index: 9999;
    }
  }
  .left,
  .right {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    position: absolute;
    top: 0;
    width: 530px;
    height: calc(100% - 8px);
    padding: 18px;
    background: url("~@/assets/dp/bottom-right.png") no-repeat center/ 100% 100%;
    z-index: 1001;
  }
  .left {
    left: 8px;
  }
  .right {
    right: 8px;
  }
}
</style>
